import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import SidebarCollapse from 'images/v5/icons/sidebar-collapse-02.svg';
import SidebarExpand from 'images/v5/icons/sidebar-expand-02.svg';
import Breadcrumbs from 'layout/atoms/Breadcrumbs/Breadcrumbs';
import Sticky from 'layout/molecules/Sticky';
import { useAppDispatch } from 'store/index';
import { selectBreadcrumbs, selectLayout, toggleShowMenu } from 'store/layoutSlice';
import styles from './Dashboard.module.scss';
function Dashboard({ headerMain, headerAside, subheader, subheaderButtons, tabs, steps, asideMenu, stickyTop, children, }) {
    const dispatch = useAppDispatch();
    const layoutState = useSelector(selectLayout);
    const breadcrumbs = useSelector(selectBreadcrumbs);
    const wrapClasses = classNames(styles.wrap);
    const headerClasses = classNames(styles.header);
    const mainClasses = classNames(styles.main, { [styles.mainWithAside]: asideMenu });
    const mainContentClasses = classNames(styles.mainContent, {
        [styles.mcWithSubheader]: subheader,
    });
    const handleButtonClick = () => {
        dispatch(toggleShowMenu());
    };
    return (React.createElement("section", { className: wrapClasses },
        React.createElement("div", null,
            React.createElement("header", { className: headerClasses },
                React.createElement("div", { className: styles.headerBreadcrumbs },
                    React.createElement("button", { className: styles.menuToggler, type: "button", onClick: handleButtonClick }, layoutState.showMenu ? React.createElement(SidebarCollapse, null) : React.createElement(SidebarExpand, null)),
                    React.createElement("span", null),
                    breadcrumbs.length > 0 && React.createElement(Breadcrumbs, { items: breadcrumbs })),
                React.createElement("main", { className: styles.headerMain }, headerMain),
                React.createElement("aside", { className: styles.headerAside }, headerAside)),
            subheader && (React.createElement("div", { className: styles.subheader },
                subheader,
                subheaderButtons && React.createElement("div", { className: styles.subheaderButtons }, subheaderButtons))),
            tabs && React.createElement("div", { className: styles.tabs }, tabs),
            steps && React.createElement("div", { className: styles.steps }, steps)),
        React.createElement("main", { className: mainClasses },
            asideMenu && React.createElement("aside", { className: styles.aside }, asideMenu),
            React.createElement("div", { id: "mainContent", className: mainContentClasses },
                stickyTop && (React.createElement(Sticky, { shadow: true },
                    React.createElement("div", { className: styles.mainPadding }, stickyTop))),
                React.createElement("div", { className: styles.mainPadding }, children)))));
}
export default Dashboard;
